import { withErrorBoundary } from '@nile/components/src';
import { cloneDeep, isEmpty } from 'lodash';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { SVGIcon } from '@superops/super-icons';
import { TextStyle } from '@superops/ui-design-system';

let broadcastChannel;
if (BroadcastChannel) {
  broadcastChannel = new BroadcastChannel('SuperShare');
}

const GlobalTicketConversationUsers = (props) => {
  const { data } = props;
  const entityId = data?.id || props?.entityId;
  const [typingViewers, setTypingViewers] = useState([]);

  broadcastChannel.onmessage = (event) => {
    if (event.data) {
      const eventData = JSON.parse(event.data);
      const { context, payload } = eventData;
      if (
        context === 'pageUpdate' &&
        payload?.page?.recordId === entityId &&
        payload?.type === 'SERVER_EVENT'
      ) {
        const clonedTypingUsers = !isEmpty(typingViewers)
          ? cloneDeep(typingViewers)
          : [];
        switch (payload.event) {
          case 'TYPING_CONVERSATION':
            const currentlyTypingUser = payload?.user;
            const isUserPresent = clonedTypingUsers.find(
              (user) => user?.userId === currentlyTypingUser?.userId
            );
            if (!isUserPresent) {
              clonedTypingUsers.push(currentlyTypingUser);
            }
            setTypingViewers(clonedTypingUsers);
            break;
          case 'STOPPED_TYPING_CONVERSATION':
            const stoppedUser = payload?.user;
            if (!isEmpty(stoppedUser) && stoppedUser?.userId) {
              const updatedUsers = clonedTypingUsers.filter(
                (user) => user?.userId !== stoppedUser?.userId
              );
              setTypingViewers(updatedUsers);
            }

            break;
          default:
            break;
        }
      }
    }
  };

  const values = typingViewers
    ?.slice(0, 2)
    ?.map((viewer) => viewer?.name)
    .join(', ');

  const classNames = ['flex g5 actr', props?.fullWidth ? 'w100' : ' mw-50p'];
  return (
    <>
      {!isEmpty(typingViewers) && !isEmpty(values) && (
        <div className={classNames}>
          <div className="flex">
            <SVGIcon name="Edit" color="#008060" />
          </div>
          <div className="ellipsis">
            <TextStyle variation="positive">
              <FormattedMessage
                id={
                  typingViewers?.length > 2
                    ? 'common.collaborator.several.typing'
                    : 'common.collaborator.isTyping'
                }
                values={{
                  collabUserName: values
                }}
              />
            </TextStyle>
          </div>
        </div>
      )}
    </>
  );
};

export default withErrorBoundary(GlobalTicketConversationUsers);
